import { BehaviorSubject, map, shareReplay, switchMap } from "rxjs";
import { Feedback } from "../models/feedback";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { FilterChip } from "../models/filter-chip";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class FeedbackService extends BaseService {
    private sortProperties : { [key: string]: string } = {

    };
    private feedbackSubject = new BehaviorSubject<Feedback[]>([]);
    feedback$ = this.feedbackSubject.asObservable();

    private sourceUpdatedSubject = new BehaviorSubject<boolean>(false);
    sourceUpdated$ = this.sourceUpdatedSubject.asObservable();

    constructor(private http: HttpClient) {
        super();
    }

    fetchfeedback() {
        this.http.get<Feedback[]>(environment.apiUrl + 'feedback/search').subscribe(feedback => {
            this.feedbackSubject.next(feedback);
        });
    }

    addFeedback(newFeedback: Feedback) {
        const post = this.http.post(environment.apiUrl + 'feedback', newFeedback);
        post.subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
        return post;
    }

    updateFeedback(updatedFeedback: Feedback) {
        this.http.put(environment.apiUrl + `feedback/${updatedFeedback.id}`, updatedFeedback).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }

    deleteFeedback(Feedback: Feedback) {
        this.http.delete(environment.apiUrl + `feedback/${Feedback.id}`).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }

    filterfeedback(filters: FilterChip[], pageSize: number = 10, pageIndex: number = 0, sortField: string | undefined = undefined, sortDirection: string | undefined = undefined) {
        return this.sourceUpdatedSubject.pipe(
            switchMap(() => {
                const keywords = filters.filter(c => c.chip == null).reduce((v, c) => v + ' ' + c.value, '');
                const propertyValues = filters.reduce((v, c) => { if (c.chip != null) v[c.chip] = c.value; return v; }, <{ [key: string]: string }>{});
                const filter = <any>{ keywords, propertyValues };
                if (pageSize) filter['pageSize'] = ''+pageSize
                if (pageIndex) filter['page'] = ''+pageIndex;
                if (sortField) filter['SortSpecifications[0].Property'] = this.sortProperties[sortField];
                if (sortDirection) filter['SortSpecifications[0].Direction'] = sortDirection == "asc" ? "Ascending" : "Descending";

                const filterQuery = this.serialize(filter);
                return this.http.get<Feedback[]>(environment.apiUrl + 'feedback/search?' + filterQuery, { observe: 'response' })
                    .pipe(
                        map(response => {
                            const paging = response.headers.get('Content-Range');
                            const total = parseInt(paging?.split("/")[1] ?? '0');
                            const feedback = response.body ?? [];
                            return { total, feedback };
                        }),
                        shareReplay()
                    );
            }));
        }
}